import { defineStore } from 'pinia'
import axios from '@axios'
import { reportError } from '@/plugins/misc'

export const useNotificationPreferencesStore = defineStore({
  id: 'notificationPreferences',

  state: () => ({
    preferences: null,
    loading: false,
    saving: false,
    error: null,
  }),

  getters: {
    // RM-446: transactional (always on) and marketing — no third category.
    emailPrefs: state => state.preferences?.email ?? {
      transactional: true,
      marketing: false,
    },
    inAppPrefs: state => state.preferences?.inApp ?? {
      transactional: true,
      marketing: true,
    },
    isGloballyUnsubscribed: state => !!state.preferences?.unsubscribedAt,
  },

  actions: {
    async fetchPreferences() {
      this.loading = true
      this.error = null
      try {
        const { data } = await axios.get('/user/notification-preferences')
        this.preferences = data.preferences
      } catch (err) {
        this.error = err?.response?.data?.message || 'Failed to load preferences'
        reportError(err)
      } finally {
        this.loading = false
      }
    },

    async updatePreference(channel, category, value) {
      if (category === 'transactional') return // transactional is immutable
      this.saving = true
      this.error = null
      try {
        const { data } = await axios.patch('/user/notification-preferences', {
          channel,
          category,
          value: Boolean(value),
        })
        this.preferences = data.preferences
      } catch (err) {
        this.error = err?.response?.data?.message || 'Failed to save preference'
        reportError(err)
        throw err
      } finally {
        this.saving = false
      }
    },
  },
})
